module.exports = __webpack_public_path__ + "media/images/icons/ihra-print-share-db4b8c124240534a697fa20d0a2940e1.svg";